import type { BlockComponentProps } from "./shared"

export function FileDownloadBlock({ content, resolved }: BlockComponentProps) {
  const fdLabel = (content?.label as string) ?? ""
  const fdUrl = (content?.url as string) ?? ""
  const fdDesc = (content?.description as string) ?? ""
  const primaryColor = "var(--nos-color-primary, #3b82f6)"
  if (!fdUrl || !fdLabel) return null
  const fdSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-4"} ${resolved.cornerClass} ${resolved.alignClass} max-w-xl`.trim()
    : "px-4 py-4 @sm:px-6 @md:px-8 max-w-xl"
  return (
    <section className={fdSectionClass} style={resolved.sectionStyle}>
      <a
        href={fdUrl}
        download
        className="flex items-center gap-3 rounded-lg border p-4 hover:bg-muted/50 transition-colors"
      >
        <span className="font-medium" style={{ color: primaryColor }}>
          {fdLabel}
        </span>
        {fdDesc && <span className="text-sm text-muted-foreground">{fdDesc}</span>}
      </a>
    </section>
  )
}
